var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !(_vm.video && _vm.video.length && _vm.isSafari)
    ? _c(
        "section",
        {
          ref: "banner",
          class: [
            "page-banner",
            {
              "page-banner--vh": _vm.hasContent,
              "page-banner--empty": !_vm.hasMedia
            }
          ]
        },
        [
          _vm.hasContent
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "scroll-reveal",
                      rawName: "v-scroll-reveal",
                      value: {},
                      expression: "{}"
                    }
                  ],
                  staticClass: "banner-tile"
                },
                [
                  _c("h2", { staticClass: "banner-tile__title" }, [
                    _vm._v(_vm._s(_vm.heading))
                  ]),
                  _c("p", { staticClass: "banner-tile__caption" }, [
                    _vm._v(_vm._s(_vm.caption))
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasContent
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "scroll-reveal",
                      rawName: "v-scroll-reveal",
                      value: { delay: 800 },
                      expression: "{delay: 800}"
                    },
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: { target: "#s-production-line" },
                      expression: "{target: '#s-production-line'}"
                    }
                  ],
                  staticClass: "page-banner__scroll-btn",
                  attrs: { href: "#s-production-line" }
                },
                [
                  _c("icon-arrow", {
                    staticClass: "page-banner__scroll-btn-icon",
                    attrs: { mod: "down" }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("transition", { attrs: { name: "banner-fade", mode: "out-in" } }, [
            _vm.imageLoaded
              ? _c("div", {
                  class: [
                    "page-banner__bg",
                    { "page-banner__bg--loaded": _vm.imageLoaded }
                  ],
                  style: { "background-image": "url(" + _vm.image + ")" }
                })
              : _vm._e()
          ]),
          _vm.video && _vm.video.length
            ? _c("div", { staticClass: "page-banner__video-box" }, [
                _c(
                  "video",
                  {
                    ref: "cover",
                    class: [
                      "page-banner__video",
                      {
                        "page-banner__video--no-object-fit": !_vm.supportObjectFit
                      }
                    ],
                    attrs: { loop: "", autoplay: "", muted: "" },
                    domProps: { muted: true },
                    on: { loadeddata: _vm.fitCover }
                  },
                  _vm._l(_vm.video, function(item) {
                    return _c("source", {
                      attrs: { src: item.src, type: item.type }
                    })
                  }),
                  0
                )
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-258384b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258384b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageBanner.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-258384b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageBanner.vue
// module chunks = 0 1 2